<script>
    export default {
        /////////////////////////////////////////////////////
        // Data
        /////////////////////////////////////////////////////
        data() {
            return {}
        },
        /////////////////////////////////////////////////////
        // Props
        /////////////////////////////////////////////////////
        props: {
            'step': {
                type: Number,
                default: 0
            },
            'dataLoaded': {
                type: Boolean,
                default: false
            }
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        computed: {
            meetsSelected () {
                return this.step > 1
            }
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        methods: {
            nextPage() {
                if (this.step == 2) {
                    window.location = '13.html'
                }
            },
            nextStep() {
                this.$emit('next', parseInt(this.step) + 1);
            },
            prevStep() {
                this.$emit('prev', parseInt(this.step) - 1);
            },
            selectMeet () {
                if (this.step == 1) {
                    this.nextStep()
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// _vue/components/Page-12.vue